import { DataItem } from 'scrivito'

import {
  buildEmployeeData,
  fetchUserRecords,
  fetchUserUtilization,
} from './useMyTeamData'
import { MyTeamEmployeeData, WeekRange } from '../../types'
import { weekRangeToApiFilters } from '../../utils/dateUtils'

export interface FetchedEmployee {
  id: string
  records: DataItem[]
  utilization: DataItem[]
}

export const fetchEmployeeData = (
  memberIds: string[],
  monthRange: WeekRange,
): FetchedEmployee[] => {
  const dateFilters = weekRangeToApiFilters(monthRange)
  return memberIds.map((id) => ({
    id,
    records: fetchUserRecords(id, dateFilters),
    utilization: fetchUserUtilization(id, monthRange),
  }))
}

export const buildEmployeesFromFetched = (
  fetched: FetchedEmployee[],
): MyTeamEmployeeData[] =>
  fetched
    .map(({ id, records, utilization }) =>
      buildEmployeeData(id, records, utilization),
    )
    .filter((e): e is MyTeamEmployeeData => e !== null)
    .sort((a, b) => a.userName.localeCompare(b.userName))
